import * as React from 'react';
import { IWithContextProps, core, withContext } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import EmailField from 'components/inputs/EmailField';
import Field from '@tock/shared/components/forms/Field';
import Fieldset from '@tock/shared/components/forms/Fieldset';
import PhoneFieldset from '@tock/shared/components/forms/fieldsets/PhoneFieldset';
import TextInput from '@tock/shared/components/inputs/DeprecatedTextInput';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any;
  isSubmitting: boolean;
  lastGuest?: StoreType['lastGuest'];
  onValidatePhone?(isPhoneValid: boolean, smsPhoneConsentStatus: core.SmsPhone.StatusType): void;
}

class GuestInputForm extends BaseComponent<Props & DefaultConnectProps & IWithContextProps> {
  emailInput: React.RefObject<TextInput>;
  passwordInput: React.RefObject<TextInput>;

  constructor(props: Props & DefaultConnectProps & IWithContextProps) {
    super(props);
    this.emailInput = React.createRef();
    this.passwordInput = React.createRef();
  }

  handleValidatePhone = (
    isPhoneValid: boolean,
    smsPhoneConsentStatus: core.SmsPhone.StatusType
  ) => {
    this.props.onValidatePhone?.(isPhoneValid, smsPhoneConsentStatus);
  };

  handleAdvanceToFieldAfterEmail() {
    if (this.passwordInput.current) {
      this.passwordInput.current.focus();
    }
  }

  render() {
    const {
      actions,
      fields: { firstName, lastName, email, phone, phoneCountryCode },
      context: { isFeatureEnabled },
    } = this.props;

    return (
      <Fieldset key="newPatron">
        <Field label="First name" labelFor="firstName" field={firstName}>
          <TextInput
            field={firstName}
            id="firstName"
            placeholder="First name"
            autoComplete="given-name"
            data-testid="patron-first-name-input"
          />
        </Field>
        <Field label="Last name" labelFor="lastName" field={lastName}>
          <TextInput
            field={lastName}
            id="lastName"
            placeholder="Last name"
            autoComplete="family-name"
            data-testid="patron-last-name-input"
          />
        </Field>
        <EmailField
          data-testid="patron-email-input"
          email={email}
          emailInput={this.emailInput}
          onAdvanceToNextField={this.handleAdvanceToFieldAfterEmail}
        />
        <PhoneFieldset
          label="Phone number"
          data-testid="patron-phone-input"
          phone={phone}
          phoneCountryCode={phoneCountryCode}
          disallowSanctionedCodes={isFeatureEnabled(
            'DISALLOW_FRONTEND_SANCTIONED_PHONE_COUNTRY_CODE_SELECTION'
          )}
          onValidatePhoneRequest={actions.patron.validatePhoneRequest}
          onValidatePhone={this.handleValidatePhone}
        />
      </Fieldset>
    );
  }
}
export default connect<Props>(withContext(GuestInputForm));
